import React from 'react';
import { Select } from 'antd';
import { useQuery } from '@tanstack/react-query';
import { I18n } from '@aws-amplify/core';

import Api from '@/services/api';
import { usePreliminaryAnalysis } from '@/components/views/PreliminaryAnalysis/context';

export const ProbabilitySelect: React.FC = (props) => {
	const { organization_id, company_id } = usePreliminaryAnalysis();

	const parameters = {
		organizationId: organization_id,
		companyId: company_id
	};

	async function getProbability({ organizationId, companyId }: any) {
		const url = `/ergonomic-tool/probabilities?organization_id=${organizationId}&company_id=${companyId}`;
		const { data } = await Api.get(url);
		return data;
	}

	const { isLoading, data } = useQuery(['probabilities', parameters], () => getProbability(parameters), {
		enabled: !!parameters.companyId && !!parameters.organizationId
	});

	return (
		<Select {...props} style={{ width: '100%' }} loading={isLoading}>
			{data?.map((item: any, index: number) => (
				<Select.Option key={index} value={item.id}>
					{I18n.get(item.description)}
				</Select.Option>
			))}
		</Select>
	);
};
